module.exports = __webpack_public_path__ + "img/lt-hover.bf4cacbd.svg";